export {Tabs, type TabsProps} from './Tabs';
